import { Injectable } from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable, of} from "rxjs";
import {FleetActionTypes, FleetSaveComplete, FleetSaveFailed} from "../actions/fleet.actions";
import {catchError, mergeMap, map} from "rxjs/operators";
import {FleetService} from "../services/fleet.service";



@Injectable()
export class FleetEffects {

  @Effect()
  saveFleet$: Observable<any> = this.actions$.pipe(
    ofType(FleetActionTypes.SaveFleet),
    mergeMap( action =>
      this.fleetService.saveFleet(action['fleet']).pipe(
        map(data => new FleetSaveComplete(data)),
        catchError((err) => of(new FleetSaveFailed(err)))
      )
    )
  )

  constructor(private actions$: Actions,
              private fleetService:FleetService) {}

}
